export const shellSx = {
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
  color: "text.primary",
  minHeight: "100vh",
  height: "100vh",
  overflow: "hidden",
};

export const bodyRowSx = {
  display: "flex",
  flex: 1,
  minHeight: 0,
  overflow: "hidden",
};

export const mainContentSx = {
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  display: "flex",
  flexDirection: "column",
  bgcolor: "background.default",
  color: "text.primary",
  p: 3,
  overflow: "hidden",
};

export const bodyTextSx = {
  marginBottom: 2,
};
